export default __webpack_public_path__ + "static/media/logo.ed13aaa4.png";